var render = function (_h,_vm) {var _c=_vm._c;return (_vm.props.data && _vm.props.data.value && _vm.props.data.value.length)?_c('div',[_vm._v(" "+_vm._s(_vm.props.data.value[0].label)+" ")]):_c(_vm.injections.components.EmptyValue,{tag:"component"})}
var staticRenderFns = []

export { render, staticRenderFns }